import type { Components } from 'react-markdown'

// Report narrative uses the app face (Geist Sans) at a reading size.
// Markdown subheadings render as plain, readable crossheads (not the
// old faint uppercase) so they don't fight the section title above.

const crosshead =
  'text-pretty text-[1.0625rem] font-semibold tracking-tight text-blue-7 mt-10 mb-3 first:mt-0'

const subCrosshead =
  'text-pretty text-[0.9375rem] font-semibold tracking-tight text-blue-7/90 mt-8 mb-2.5 first:mt-0'

const proseBody = 'text-pretty text-[0.9375rem] leading-relaxed text-blue-7'

export const REPORT_PROSE: Partial<Components> = {
  // Section bodies render under the section's own title, so markdown
  // headings demote to crossheads instead of competing with it.
  h2: ({ node, children }) => <h3 className={crosshead}>{children}</h3>,
  h3: ({ node, children }) => <h4 className={subCrosshead}>{children}</h4>,
  p: ({ node, children }) => (
    <p className={`${proseBody} not-first:mt-5`}>{children}</p>
  ),
  ul: ({ node, children }) => (
    <ul className={`${proseBody} my-5 ml-6 list-disc [&>li]:mt-2.5`}>
      {children}
    </ul>
  ),
  ol: ({ node, children }) => (
    <ol className={`${proseBody} my-5 ml-6 list-decimal [&>li]:mt-2.5`}>
      {children}
    </ol>
  ),
  li: ({ node, children }) => (
    <li className="text-pretty leading-relaxed pl-1">{children}</li>
  ),
  blockquote: ({ node, children }) => (
    <blockquote
      className={`${proseBody} my-6 border-l-2 border-brand/40 pl-5 italic`}
    >
      {children}
    </blockquote>
  ),
}
